import { render, staticRenderFns } from "./Formateurs.vue?vue&type=template&id=05ae6046"
import script from "./Formateurs.vue?vue&type=script&lang=js"
export * from "./Formateurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports